import styled from '@emotion/styled';

const ChartWrapper = styled.div`
  .h3 {
    margin-bottom: 16px;

    @media (min-width: ${(props) => props.theme.breakpoints.mobile_landscape}) {
      margin-bottom: 24px;
    }
  }

  .y-axis-label {
    margin: 0 0 -20px 6px;
    font-weight: bold;

    @media (min-width: ${(props) => props.theme.breakpoints.mobile_landscape}) {
      margin: 0;
    }
  }
`;

export { ChartWrapper };
